
export enum EQuantityValidationResult {
    Unvalidated = 0,
    Valid = 1,
    BelowMinium = 2,
    AboveMaximum = 3
}
